export default [
    {
        id: 1,
        name: 'Salarios'
    },
    {
        id: 2,
        name: 'Alquiler'
    },
    {
        id: 3,
        name: 'Servicios públicos'
    },
    {
        id: 4,
        name: 'Impuestos'
    },
    {
        id: 5,
        name: 'Transporte'
    },
    {
        id: 6,
        name: 'Gastos financieros'
    },
    {
        id: 7,
        name: 'Imprevistos'
    },
]
